import { createSelector } from '@reduxjs/toolkit';
import { selectExperiments } from './selectExperiments';
import { isExperimentActive } from 'shared/utils/experiments';
import { DAILY_RENT_OTA_CONVERSION } from 'shared/constants/experiments';
import { IConfig } from '@cian/config/shared';

export const selectIsDailyRentOtaConversionExperimentEnabled = (config: IConfig) =>
  createSelector(selectExperiments, experiments => {
    const isParticipateInExperiment = Boolean(
      config.get<boolean>('Dailyrent.WithoutInstantBookingFilterExperiment.Enabled'),
    );

    return isExperimentActive(experiments, DAILY_RENT_OTA_CONVERSION, 'B') && isParticipateInExperiment;
  });
